import { Building2, Folder, Wrench } from "lucide-react";
import type { TagType } from "@/app/types/tags";

export const TAG_TYPES = ["branch", "department", "service"] as const;

export type TagTypeConst = (typeof TAG_TYPES)[number];

export const tagColors: Record<TagTypeConst, { bgLight: string; bgDark: string; text: string; border: string }> = {
  branch: {bgLight: "bg-blue-100/50", bgDark: "bg-blue-600", text: "text-blue-800", border: "border-blue-200"},
  department: {bgLight: "bg-emerald-100/50", bgDark: "bg-emerald-600", text: "text-emerald-800", border: "border-emerald-200"},
  service: {bgLight: "bg-amber-100/50", bgDark: "bg-amber-600", text: "text-amber-800", border: "border-amber-200"},
}

export const allowedChildrenByTagType: Record<TagType, TagType[]> = {
  branch: ["department", "service"],
  department: ["service"],
  service: ["service"],
};

export const typeIconMap: Record<TagType, React.ComponentType<{ className?: string }>> = {
  branch: Building2,
  department: Folder,
  service: Wrench,
};

export const isPathEqual = (pathA: number[], pathB: number[]) =>
  pathA.length === pathB.length &&
  pathA.every((value, index) => value === pathB[index]);

export const pathListIncludesPath = (needle: number[], haystack: number[][]) =>
  haystack.some(path => isPathEqual(path, needle))
